import { render } from "./Tab.vue?vue&type=template&id=21028957&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=21028957&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-21028957"

export default script